// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3n-yX","validationTips":"StatementDescriptor_validationTips__3EMdg"};